import React from 'react'

const EmptyItem = ({text}) => {
  return (
   
    <div className={` w-full bg-white font-museobb rounded-lg my-5 min-h-[150px] text-center flex justify-center items-center `}
        style={{ "boxShadow": "rgb(210 206 206 / 82%) 3px 5px 20px 1px" }} >
        <h6>{text !== undefined ? text : 'No Task Found !'}</h6>
    </div>

  )
}

export default EmptyItem
